export default "__VITE_ASSET__$4SOtV1L__"